import { keepPreviousData, queryOptions, skipToken } from '@tanstack/react-query'
import { keys } from './keys'
import {
  fetchCameraStreams,
  fetchStore,
  fetchStoreCamera,
  fetchStoreCameraConfig,
  fetchStoreCameraIds,
  fetchStoreCameraViewSession,
  fetchStoreCameras,
  fetchStores,
} from './stores.queries'

export const getStoresOptions = () =>
  queryOptions({
    queryKey: keys.stores.list(),
    queryFn: fetchStores,
  })

export const getBoutiquesOptions = () =>
  queryOptions({
    ...getStoresOptions(),
    select: (data) =>
      data.filter((store) => store.storeType === 'BOUTIQUE' || store.storeType === 'REMOTE'),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60, // 5 minutes
  })

export const getWarehousesOptions = () =>
  queryOptions({
    ...getStoresOptions(),
    select: (data) => data.filter((store) => store.storeType === 'WAREHOUSE'),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60,
  })

export const getStoreOptions = (id: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.byId(id),
    queryFn: id !== undefined ? () => fetchStore(id) : skipToken,
  })

export const getStoreCameraConfigOptions = (storeId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraConfig.summary(storeId),
    queryFn: storeId !== undefined ? () => fetchStoreCameraConfig(storeId) : skipToken,
  })

export const getStoreCameraViewSessionOptions = (storeId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraConfig.viewSession(storeId),
    queryFn: storeId !== undefined ? () => fetchStoreCameraViewSession(storeId) : skipToken,
  })

export const getStoreCameraListOptions = (storeId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraConfig.cameras.list(storeId),
    queryFn: storeId !== undefined ? () => fetchStoreCameras(storeId) : skipToken,
  })

export const getStoreCameraOptions = (storeId: number | undefined, cameraId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraConfig.cameras.byId(storeId, cameraId),
    queryFn:
      storeId !== undefined && cameraId !== undefined
        ? () => fetchStoreCamera(storeId, cameraId)
        : skipToken,
  })

export const getCameraStreamOptions = (storeId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraStream(storeId),
    queryFn: storeId !== undefined ? () => fetchCameraStreams(storeId) : skipToken,
  })

export const getStoreCameraIdsOptions = (storeId: number | undefined) =>
  queryOptions({
    queryKey: keys.stores.cameraIds(storeId),
    queryFn: storeId !== undefined ? () => fetchStoreCameraIds(storeId) : skipToken,
    staleTime: 5 * 60 * 1000,
  })
